import React from "react";
import { CContainer, CSpinner } from "@coreui/react-pro";

const Loading = ({ inner }) => {
  return (
    <>
      <CContainer className={inner ? "loading-inner" : "loading-full-height"}>
        <CSpinner color="secondary" style={{ width: "3rem", height: "3rem" }} />
      </CContainer>
    </>
  );
};

export default Loading;
